<template style="bottom: 0; left: 0;">
	<div class="row position-absolute" style="bottom: 0; left: 0;">
		<div class="d-flex justify-content-end p-rotate-90">
			<button
				v-for="(measExtra, index) in getMeas"
				:key="index"
				class="secondary-btn text-uppercase extras-btn"
				:class="{ 'btn-active': currentTable.code === measExtra.code }"
				@click="showMeasurementTable(measExtra.code)"
				variant="primary"
			>
				<p class="m-0">{{ measExtra.button }}</p>
			</button>
		</div>

		<div
			v-if="currentTable.code=='p1'"
			class="col d-flex px-0 mt-4"
			:class="{ 'measurement-table-limited': isLayoutLimited }"
			style="height: fit-content"
		>
			<personal-measurements
				class="position-absolute" style="bottom:0;left:5px">
			</personal-measurements>
		</div>
		<div
			v-if="currentTable.code!='p1'"
			class="col d-flex px-0 mt-4"
			:class="{ 'measurement-table-limited': isLayoutLimited }"
			style="height: fit-content"
		>
			<div class="position-absolute" style="bottom:0;left:5px" v-html="translateHtml(currentTable.table)"></div>
		</div>
	</div>
</template>

<script>
import PersonalMeasurements from './MeasurementTables/personalMeasurements';
import { makeDraggable } from "../../../../shared/utils/draggable";
import anchor from '@/assets/images/extras/anchor.png'

export default {
	components: {
		PersonalMeasurements,
	},

	data() {
		return {
			currentTable: false,
			measurements: [],
		}
	},

	async mounted() {
		this.measurements = await this.getLessonMeasurements();
	},

	computed: {
		isLayoutLimited() { return ['xs', 'sm', 'md'].includes(this.$getViewport()); },

		getMeas(){
			const ret = this.measurements?.flatMap(p => {
				return { button: p.button, code: p.code };
			});
			return ret;
		}
	},

	methods: {
		translateHtml(html) {
			return html?.replace(
				/\{\{\s*\$t\(['"]([^'"]+)['"]\)\s*\}\}/g,
				(_, key) => this.$t(key)
			).replace(
				/src=["']anchor\.png["']/g,
				`src="${anchor}"`
			)
		},

		async getLessonMeasurements(){
			const lesson = await this.$store.dispatch('lessons/fetchLessonContent', {
				productKey: this.$store.getters.getSelected.lesson.folder,
				lessonKey: this.$store.getters.getSelected.lesson.key
			});
			return [...lesson.props.measurements, {code: 'p1', button: 'M'}];
		},

		showMeasurementTable(code) {
			this.currentTable = this.currentTable?.code !== code ? this.measurements.find(x=>x.code===code) : false;
			setTimeout(() => {
				let mt = document.querySelector('.measurement-table');
				if (mt) makeDraggable(mt);
			}, 100);
		}
	}

}
</script>

<style scoped>
.measurement-table-limited {
	transform: scale(.5);
}
.secondary-btn {
	font-weight: bold;
	color: white;
	background-color: lightgrey;
	border: 1px solid lightgrey;
	border-radius: 20px;
}
.secondary-btn:hover, .btn-active {
	color: #1a96cf;
	background-color: white;
	border: 1px solid #1a96cf;
}
.extras-btn {
	padding: 5px 15px;
	margin-left: 5px;
}

.p-rotate-90 {
	white-space: nowrap;
	padding: 0;
	margin: 0;
    transform-origin: bottom left;
    transform: rotate(90deg) translateY(100%) translateX(-100%);
}
</style>

<style>
.measurement-table {
	position: absolute;
	bottom: 0;
	min-width: 500px;
	background: white;
	box-shadow: rgba(100, 100, 111, 0.8) 0px 7px 29px 0px;
	z-index: 9999;
}
.measurement-table, .measurement-table td {
	text-align: center;
	border-collapse: collapse;
	border: 1px solid #1a96cf;
}
</style>
